var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescargarCompulsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Descargar-compulsa",
    transform: "translate(11892.383 16218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24806",
    "data-name": "Trazado 24806",
    d: "M12.5,25A12.5,12.5,0,1,1,25,12.5,12.514,12.514,0,0,1,12.5,25m0-23.809A11.309,11.309,0,1,0,23.808,12.5,11.321,11.321,0,0,0,12.5,1.191",
    transform: "translate(-11892.383 -16218)",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    transform: "translate(-11890.097 -16215.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24807",
    "data-name": "Trazado 24807",
    d: "M15.928,22.5v2.539a1.27,1.27,0,0,1-1.27,1.27H5.77a1.27,1.27,0,0,1-1.27-1.27V22.5",
    transform: "translate(0 -10.382)",
    fill: "none",
    stroke: "#d5007f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24808",
    "data-name": "Trazado 24808",
    d: "M10.5,15l3.174,3.174L16.849,15",
    transform: "translate(-3.461 -6.056)",
    fill: "none",
    stroke: "#d5007f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24809",
    "data-name": "Trazado 24809",
    d: "M18,12.118V4.5",
    transform: "translate(-7.786)",
    fill: "none",
    stroke: "#d5007f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescargarCompulsa);
export default __webpack_public_path__ + "static/media/Descargar-compulsa.8e07b360eed6bc38a2ec41a21f2da35d.svg";
export { ForwardRef as ReactComponent };